<template>
  <div class="gcplog">
    <div class="header">
      <img class="loginlogo" src="@/images/airudderLogo.png" />
      <div class="header-rl" @click="login">
        <div class="login-btn" v-if="!mail">Login</div>
        <el-dropdown @command="handleCommand" v-else>
          <span class="el-dropdown-link">
            {{ mail }} <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command='logout'>Logout</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <img class="avatar" src="@/images/avatar.png" />
      </div>
    </div>
    <div class="content">
      <img class="operating-floor" src="@/images/login-operating-floor.png" />
      <div class="max-w">
        <div class="title"> Intelligent outbound call conference assistant. </div>
        <div class="tip">An application designed to simplify the process of arranging meetings. <br />Through this application, you can authorize us to access your Google Calendar so that we can provide you  <br /> with more convenient meeting scheduling services.</div>
        <Calendar style="padding-right: 320px" :is-login="!!mail"/>
      </div>
    </div>
    <div class="footer">
      <div>Business Cooperation: sales@airudder.com</div>
      <div>Copyright 2024 airudder.com</div>
    </div>
    <Login v-model="showLogin" />
  </div>
</template>

<script>
import Calendar from './calendar.vue'
import Login from './login.vue'
export default {
  components: {
    Calendar,
    Login
  },
  data() {
    return {
      mail: localStorage.getItem('mail'),
      showLogin: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const { msg, mail } = this.$route.query
      if (msg) {
        this.$router.replace(this.$route.path)
        if (msg === 'success') {
          localStorage.setItem('mail', mail)
          this.mail = mail
        } else {
          this.$message({
            type: 'error',
            message: msg
          })
        }
      }
      if (!this.mail) this.showLogin = true
    },
    login() {
      if (this.mail) return
      this.showLogin = true
    },
    handleCommand(e) {
      switch (e) {
      case 'logout':
        this.logoutSJ()
        break
      }
    },
    logoutSJ() {
      localStorage.removeItem('mail')
      this.mail = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.gcplog{
  height: 100%;
  overflow-y: auto;
  background: #efefef;
  >.header{
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
    background: #fff;
    >img{
      height: 46px;
    }
    .login-btn{
      cursor: pointer;
    }
    .header-rl{
      display: flex;
      align-items: center;
      cursor: pointer;
      gap: 8px;
      >.avatar{
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
  }
  >.content{
    padding: 20px;
    background: #009ee1;
    color: #fff;
    position: relative;
    .title{
      font-size: 32px;
      font-weight: bold;
    }
    .tip{
      margin: 20px 0 32px 0;
      line-height: 1.5;
    }
  }
  .operating-floor{
    width: 300px;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 100;
  }
  .max-w{
    max-width: 1280px;
    margin: 0 auto;
  }
  >.footer{
    padding: 40px 20px;
    color: #666;
    font-size: 12px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/gcplog/index.vue